export const configDistance = [
  {
    name: 'Within 2 km',
    min: 0,
    max: 2,
    key: 'kmLess2',
  },
  {
    name: 'Between 2 km and 5 km',
    min: 2,
    max: 5,
    key: 'kmGe2',
  },
  {
    name: 'More than 10 km',
    min: 10,
    key: 'kmMore10',
  },
];

export const defaultTempExport = () => {};
